import React from "react";
import { Link } from "react-router-dom";
import { fetchAll, deleteOne } from "actions/location";
import { connect } from "react-redux";
import DeleteModal from "components/DeleteModal";
import UpdateLocationModal from "components/UpdateLocationModal";

const mapStateToProps = state => ({
  location: state.location.byId,
  deleteErrors: state.location.deleteErrors
});

const mapDispatchToProps = {
  fetchAll,
  deleteOne
};

class AdminLocationList extends React.Component {
  componentWillMount() {
    this.props.fetchAll();
  }

  render() {
    const locations = Object.keys(this.props.location).map(
      id => this.props.location[id]
    );
    const { deleteErrors } = this.props;
    return (
      <div>
        <Link to="/admin/location/create">
          <button className="btn btn-danger mb-2">Legg til lokasjon</button>
        </Link>
        <table className="table">
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Navn/Adresse</th>
              <th scope="col">Handlinger</th>
            </tr>
          </thead>
          <tbody>
            {locations.map(location => (
              <tr key={location.id}>
                <th scope="row">{location.id}</th>
                <td>{location.name}</td>
                <td>
                  <div className="btn-toolbar">
                    <UpdateLocationModal
                      onSubmit={this.props.updateOne}
                      title={
                        "Redigerer ID " + location.id + " - " + location.name
                      }
                      location={location}
                    />
                    <DeleteModal
                      errors={deleteErrors}
                      onDelete={this.props.deleteOne}
                      title={"[" + location.id + "] " + location.name}
                      id={location.id}
                    >
                      Lokasjon: {location.name}
                    </DeleteModal>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminLocationList);



// WEBPACK FOOTER //
// ./src/components/AdminLocationList.js